export default Object.freeze({
  Completions: 1,
  Agent: 2,
  Responses: 3,
});
